// extracted by mini-css-extract-plugin
export var companyImages = "AdPage-module--companyImages--c25c3";
export var customFont = "AdPage-module--customFont--e2222";
export var heading = "AdPage-module--heading--a902c";
export var sketchParent = "AdPage-module--sketchParent--2836d";
export var whyCrioImage = "AdPage-module--whyCrioImage--357e9";